import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LoginHelpPage } from './LoginHelpPage';
import { LoginPage } from './LoginPage';
import { ResetPasswordPage } from './ResetPasswordPage';
import { HelpRequestPage } from '../help/HelpRequestPage';
import { SocialAuthCompletePage } from './SocialAuthCompletePage';
import { PeopleMemberSignUpPage } from '../people/PeopleMemberSignUpPage';
import { PeopleRegisterPage } from '../people/PeopleRegisterPage';
import { PeopleRegisterStep2Page } from '../people/PeopleRegisterStep2Page';

export const PublicAuthRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/site/loginhelp" element={<LoginHelpPage />} />
        <Route path="/loginhelp" element={<LoginHelpPage />} />
        <Route path="/login-help" element={<LoginHelpPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/people/resetPass" element={<ResetPasswordPage />} />
        <Route path="/password/reset" element={<ResetPasswordPage />} />

        <Route path="/site/helpRequest" element={<HelpRequestPage />} />
        <Route path="/site/helprequest" element={<HelpRequestPage />} />
        <Route path="/help-request" element={<HelpRequestPage />} />
        <Route path="/helprequest" element={<HelpRequestPage />} />

        <Route path="/site/login" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/social-complete" element={<SocialAuthCompletePage />} />
        <Route path="/people/register" element={<PeopleRegisterPage />} />
        <Route path="/people/registerStep2" element={<PeopleRegisterStep2Page />} />
        <Route path="/people/memberSignUp" element={<PeopleMemberSignUpPage />} />

        {/* Keep requested URL intact, but show Login by default */}
        <Route path="*" element={<LoginPage />} />
      </Routes>
    </BrowserRouter>
  );
};
